import { Controller } from '@hotwired/stimulus';

// Volume ou DN d'un ESP, l'un ou l'autre : saisir l'un rend l'autre inactif
// (cibles : blocs des deux champs).
export default class extends Controller {
    static targets = ['capacity', 'dn'];

    connect() {
        this.sync();
    }

    sync() {
        const capacity = this.input(this.capacityTarget).value !== '';
        const dn = this.input(this.dnTarget).value !== '';
        this.lock(this.capacityTarget, dn && !capacity);
        this.lock(this.dnTarget, capacity && !dn);
    }

    input(block) {
        return block.querySelector('input');
    }

    lock(block, locked) {
        block.inert = locked;
        block.classList.toggle('opacity-60', locked);
    }
}
